import styled from 'styled-components';
import ProjectCard from '../ProjectCard';
import Projects from '../../portoflio.json';
const ProjectCardList = ({ catActive }) => {
  return (
    <Container_grid>
      {Projects.map((project) => {
        return (
          <ProjectCard
            key={project.id}
            catActive={catActive}
            project={project}
            className="animate__animated animate__fadeInUp"
          />
        );
      })}
    </Container_grid>
  );
};

export default ProjectCardList;
export const Container_grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  padding: 0 50px;
  padding-left: 13.5rem;
  @media (max-width: 768px) {
    margin-top: 0;
  }
`;
